import React, { Component } from "react";
import clsx from 'clsx';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from "prop-types";
import { CssBaseline, CircularProgress, Container, Grid, IconButton, Tooltip } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { Styles } from "../../styles/material-styles";
import { Overlay } from "../../styles/global";
import CustomizedSnackbars from "../../components/material-snackbars";
import HeaderMenu from "../../components/header-menu";
import Footer from '../../components/footer';
import { FormattedMessage, injectIntl } from 'react-intl';
import SectionCard from '../../components/section-card';
import Typography from '@material-ui/core/Typography';
import Pagination from '@material-ui/lab/Pagination';
import RefreshIcon from '@material-ui/icons/Refresh';
import MyMaterialTable from '../../components/table';
import EmptyStateCard from '../../components/empty-state-card';
import PaymentIcon from '@material-ui/icons/Payment';
import * as componentActions from '../../redux/actions/admin-billing';
import * as adminBillingService from '../../services/admin-billing.service';
import Api from "../../services/api";

const PAGE_SIZE = 10;

class AdminFailedPayments extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            openNotification: false,
            notificationVariant: "error",
            notificationMessage: "",
            resultList: [],
            totalPages: 0,
            page: 1,
            pageStart: 0,
            pageEnd: 0,
            count: 0,
        };
        this.closeNotification = this.closeNotification.bind(this);
    }

    componentDidMount() {
        this.getItens(1);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.location.state === "reload") {
            this.componentDidMount();
        }
    }

    onChangePaginate = (e, page) => {
        this.setState({ page: page });
        this.getItens(page);
    }

    setPagination(count, page) {
        let totalPage = Math.ceil(count / PAGE_SIZE);
        this.setState({ totalPages: totalPage });
        if (count > 0) {
            if (page == 1) {
                this.setState({ pageStart: 1, pageEnd: Math.min(count, PAGE_SIZE) });
            } else {
                let pageStart = ((page - 1) * PAGE_SIZE) + 1;
                this.setState({ pageStart: pageStart, pageEnd: Math.min(page * PAGE_SIZE, count) });
            }
        } else {
            this.setState({ totalPages: 0, page: 1, count: 0 });
        }
    }

    getItens(page = 1) {
        this.setState({ loading: true });
        const offset = (page - 1) * PAGE_SIZE;

        adminBillingService.getFailedPayments(PAGE_SIZE, offset)
            .then(result => {
                if (result.data.success) {
                    const data = result.data.data;
                    const count = data.totalcount || 0;
                    const payments = data.payments || [];
                    this.setState({ count: count });
                    this.setPagination(count, page);

                    const formattedList = payments.map(item => ({
                        ...item,
                        paymentDateText: item.paymentdate ? new Date(item.paymentdate).toLocaleDateString('pt-BR') : '-',
                        valueText: item.value != null ? `${item.currency || 'BRL'} ${item.value.toFixed(2)}` : '-',
                    }));

                    this.setState({ loading: false, resultList: formattedList });
                } else {
                    const intl = this.props.intl;
                    this.setState({
                        loading: false, openNotification: true, notificationVariant: "error",
                        notificationMessage: result.data.errors ? result.data.errors[0] : intl.formatMessage({ id: "process.error" })
                    });
                }
            })
            .catch(err => {
                const intl = this.props.intl;
                this.setState({
                    loading: false, openNotification: true, notificationVariant: "error",
                    notificationMessage: err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                });
                Api.kickoff(err);
            });
    }

    handleRetry = (e, paymentId) => {
        e.stopPropagation();
        const intl = this.props.intl;
        this.setState({ loading: true });

        adminBillingService.retryPayment(paymentId)
            .then(result => {
                if (result.data.success) {
                    this.setState({
                        loading: false,
                        openNotification: true,
                        notificationVariant: 'success',
                        notificationMessage: intl.formatMessage({ id: "admin.billing.retry.success" })
                    });
                    this.getItens(this.state.page);
                } else {
                    this.setState({
                        loading: false, openNotification: true, notificationVariant: 'error',
                        notificationMessage: result.data.errors ? result.data.errors[0] : intl.formatMessage({ id: "process.error" })
                    });
                }
            })
            .catch(err => {
                this.setState({
                    loading: false, openNotification: true, notificationVariant: 'error',
                    notificationMessage: err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                });
                Api.kickoff(err);
            });
    }

    closeNotification() {
        this.setState({ openNotification: false });
    }

    render() {
        const { classes, headerMenu } = this.props;
        const intl = this.props.intl;

        return (
            <div className={classes.root} style={{ paddingLeft: 0, marginLeft: 0 }}>
                <HeaderMenu />
                <main className={clsx(classes.content, { [classes.contentShift]: headerMenu.open })}>
                    <div className={classes.drawerHeader} />
                    <Container component='main' maxWidth='xl' style={{ paddingLeft: 0, marginLeft: 0 }}>
                        <CssBaseline />

                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                <SectionCard
                                    context="danger"
                                    title={intl.formatMessage({ id: "admin.billing.failed.payments" })}
                                    subtitle="Pagamentos com falha de cobrança — reprocessar ou investigar no gateway"
                                    divider={false}
                                />
                            </Grid>
                        </Grid>

                        {this.state.resultList.length === 0 && !this.state.loading ? (
                            <EmptyStateCard
                                context="success"
                                icon={<PaymentIcon style={{ fontSize: 56, color: '#bdbdbd' }} />}
                                title="Nenhuma cobrança com falha"
                                description="Todas as cobranças estão em dia. Nada a investigar no momento."
                            />
                        ) : (
                            <MyMaterialTable
                                title=""
                                columns={[
                                    { title: intl.formatMessage({ id: "name" }), field: 'hirername' },
                                    { title: 'Workspace', field: 'workspace' },
                                    { title: intl.formatMessage({ id: "admin.payment.value" }), field: 'valueText' },
                                    { title: intl.formatMessage({ id: "admin.payment.date" }), field: 'paymentDateText' },
                                    { title: intl.formatMessage({ id: "admin.payment.failure.code" }), field: 'failurecode' },
                                    { title: intl.formatMessage({ id: "admin.payment.failure.message" }), field: 'failuremessage' },
                                    {
                                        title: intl.formatMessage({ id: "admin.billing.retry" }),
                                        field: 'id',
                                        render: rowData => (
                                            <Tooltip title={intl.formatMessage({ id: "admin.billing.retry" })}>
                                                <IconButton size="small" onClick={(e) => this.handleRetry(e, rowData.id)}>
                                                    <RefreshIcon fontSize="small" />
                                                </IconButton>
                                            </Tooltip>
                                        )
                                    },
                                ]}
                                data={this.state.resultList}
                                rowClick={(event, rowData) => {
                                    this.props.addCurrentHirer({ hirerid: rowData.hirerid, name: rowData.hirername, workspace: rowData.workspace });
                                    this.props.history.push(`/${this.props.match.params.lang}/admin-subscription-detail`);
                                }}
                            />
                        )}

                        <Grid container style={{ marginBottom: 12, marginTop: 8 }}>
                            <Grid item xs={12} md={3}>
                                <Pagination count={this.state.totalPages} page={this.state.page} onChange={this.onChangePaginate} />
                            </Grid>
                            <Grid item xs={12} sm={3} style={{ marginTop: 6 }}>
                                {this.state.pageStart} {<FormattedMessage id="to" />} {this.state.pageEnd} {<FormattedMessage id="of" />} {this.state.count} {<FormattedMessage id="register" />}
                            </Grid>
                        </Grid>

                        {this.state.loading && (
                            <Overlay>
                                <CircularProgress color="secondary" />
                            </Overlay>
                        )}
                        <CustomizedSnackbars
                            variant={this.state.notificationVariant}
                            message={this.state.notificationMessage}
                            isOpen={this.state.openNotification}
                            toClose={this.closeNotification}
                        />
                    </Container>
                </main>
                <Footer />
            </div>
        );
    }
}

AdminFailedPayments.propTypes = {
    classes: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    headerMenu: state.headerMenu,
    userSession: state.userSession,
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(componentActions, dispatch);

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(withStyles(Styles)(AdminFailedPayments)));
